import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade modal-md",
  id: "ModalPlanilhaLubrificanteTransmissao",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-dialog-scrollable modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = {
  class: "modal-content",
  style: {"border-radius":"15px"}
}
const _hoisted_5 = { class: "modal-header p-5" }
const _hoisted_6 = { class: "d-flex gap-4 p-0 align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  style: {"background":"rgb(236, 236, 236)"},
  class: "p-3 rounded"
}, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"height":"fit-content","width":"fit-content","font-size":"18px","color":"#203972 !important"},
    class: "m-0 fas fa-pencil-alt"
  })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 subtitulo cor_texto_1" }, "Detalhes da planilha", -1)
const _hoisted_9 = { class: "m-0 legenda text-muted" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("svg", {
  height: "2em",
  fill: "#afb7bd",
  widxmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z" })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  class: "modal-body background_2",
  style: {"height":"400px"},
  id: "modalBody"
}
const _hoisted_13 = { class: "d-flex flex-column gap-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto bold cor_texto_1" }, "Informações da planilha", -1)
const _hoisted_15 = {
  style: {"border-radius":"10px"},
  class: "d-flex flex-column overflow-hidden p-5 w-100 background_1"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "mb-2 cor_texto_1 text-nowrap text-truncate overflow-hidden text-nowrap text-truncate overflow-hidden" }, "Nome:", -1)
const _hoisted_17 = ["title"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "my-2 cor_texto_1 text-nowrap text-truncate overflow-hidden text-nowrap text-truncate overflow-hidden" }, [
  /*#__PURE__*/_createTextVNode("Status: "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_19 = ["title"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 texto bold cor_texto_1" }, "Detalhe do erro", -1)
const _hoisted_21 = {
  style: {"border-radius":"10px"},
  class: "d-flex flex-column overflow-hidden p-5 w-100 background_1"
}
const _hoisted_22 = {
  key: 0,
  class: "m-0 texto bold text-muted",
  style: {"padding":"2rem","text-align":"center"}
}
const _hoisted_23 = {
  key: 1,
  class: "mb-2 cor_texto_1 text-nowrap text-truncate overflow-hidden text-nowrap text-truncate overflow-hidden"
}
const _hoisted_24 = {
  key: 2,
  class: ""
}
const _hoisted_25 = { class: "modal-footer d-flex flex-nowrap justify-content-end align-items-center p-5 gap-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "2em",
  fill: "white",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", null, [
                _hoisted_8,
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.arquivoInfo.data ? `Adicionado ${_ctx.arquivoInfo.data}` : 'Data desconhecida'), 1)
              ])
            ]),
            _createElementVNode("div", {
              class: "cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal())),
              "aria-label": "Close"
            }, _hoisted_11)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("section", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                  class: "p-2",
                  placeholder: "Digite...",
                  title: _ctx.arquivoInfo.nome,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.arquivoInfo.nome) = $event)),
                  disabled: ""
                }, null, 8, _hoisted_17), [
                  [_vModelText, _ctx.arquivoInfo.nome]
                ]),
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
                  class: "p-2",
                  placeholder: "Digite...",
                  title: _ctx.arquivoInfo.status,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.arquivoInfo.status) = $event)),
                  disabled: ""
                }, null, 8, _hoisted_19), [
                  [_vModelText, _ctx.arquivoInfo.status]
                ])
              ]),
              _hoisted_20,
              _createElementVNode("section", _hoisted_21, [
                (!_ctx.arquivoInfo.erro)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_22, "Não foi encontrado erro."))
                  : _createCommentVNode("", true),
                (_ctx.arquivoInfo.erro)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_23, "Erro:"))
                  : _createCommentVNode("", true),
                (_ctx.arquivoInfo.erro)
                  ? (_openBlock(), _createElementBlock("code", _hoisted_24, _toDisplayString(_ctx.arquivoInfo.detalheErro), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.baixaPlanilha())),
              style: {"height":"fit-content","white-space":"nowrap"},
              class: "btn btn-danger d-flex flex-row gap-3 px-5 py-2 justify-content-center align-items-center m-0 texto"
            }, [
              _hoisted_26,
              _createTextVNode(" Baixar ")
            ])
          ])
        ])
      ])
    ])
  ]))
}